import React, { useState } from 'react'
import { Button, Form, Badge } from 'react-bootstrap'
import Select from 'react-select'
import _ from 'lodash'

import * as Constants from '../../../helpers/constants'
import * as MiscellaneousConstants from '../helpers/constants'
import showToastNotification from '../../widgets/toastify'
import { ApiHelper } from '../../../helpers/apihelper'


const initialState = {
  sys_type: MiscellaneousConstants.SYS_TYPE_OPTIONS[0],
  domains_input: '',
  domains: [],
  desc: '',
}

const UpdateSysprop = ({ client }) => {
  const [state, setState] = useState(initialState)

  const handleTypeChange = (option) => {
    setState({
      sys_type: option,
      domains_input: '',
      domains: [],
      desc: '',
    })
  }

  const splitDomains = (input) => {
    return input
      .split(/[, ;\n]+/)
      .map(d => d.trim())
      .filter(d => d.length)
  }

  const handleInputChange = (e) => {
    const value = e.target.value
    const domainList = splitDomains(value)

    setState(prev => ({
      ...prev,
      domains_input: value,
      domains: domainList
    }))
  }

  const handleBlur = () => {
    const domainList = splitDomains(state.domains_input)

    setState(prev => ({
      ...prev,
      domains: domainList
    }))
  }

  const handleDescChange = (e) => {
    setState(prev => ({
      ...prev,
      desc: e.target.value
    }))
  }

  const removeDomain = (index) => {
    const updated = [...state.domains]
    updated.splice(index, 1)
    setState(prev => ({
      ...prev,
      domains: updated,
      domains_input: updated.join(', '),
    }))
  }

  const handleSubmit = () => {
    const body = {
      name: state.sys_type.value,
      desc: state.desc,
      value: state.domains,
    }

    ApiHelper(client, 'UPDATE_SYSPROP').API(client, body)
      .then((response) => {
        if (response.status === Constants.CO_API.SUCCESS) {
          showToastNotification({
            message: 'Sysprop updated successfully',
            isSuccess: true
          })
          setState(initialState)
        } else {
          let errorMessage = _.get(response, 'error.message', 'Failed to update sysprop')
          showToastNotification({
            message: errorMessage,
            isSuccess: false
          })
        }
      })
      .catch((err) => {
        console.error(err)
        showToastNotification({
          message: 'Something went wrong',
          isSuccess: false
        })
      })
  }

  return (
    <div className='mis-wrapper'>
      <h5 className='heading-title'>Update Sysprop</h5>
      <p className='heading-subtext'>
        Update Invalid, Unknown, CatchAll Sysprop domains
      </p>
      <Form className='mt-4'>
        <Form.Group >
          <Form.Label
            className='mb-1'
          >
            Domain type:
          </Form.Label>
          <div className='sysprop-select-wrapper'>
            <Select
              options={MiscellaneousConstants.SYS_TYPE_OPTIONS}
              value={state.sys_type}
              onChange={handleTypeChange}
              isSearchable={false}
              menuPortalTarget={document.body}
              menuPosition='fixed'
            />
          </div>
        </Form.Group>
        <Form.Group className='mt-4'>
          <Form.Label
            htmlFor='update-sysprop-domains__description'
            className='mb-1'
          >
            Description:
          </Form.Label>
          <Form.Control
            type='text'
            id='update-sysprop-domains__description'
            placeholder='Enter description'
            value={state.desc}
            onChange={handleDescChange}
          />
        </Form.Group>
        <Form.Group className='mt-4'>
          <Form.Label
            className='mb-1'
            htmlFor='update-sysprop-domains__input'
          >
            Enter Domains:
          </Form.Label>
          <Form.Control
            type='text'
            id='update-sysprop-domains__input'
            placeholder={state.sys_type.placeholder}
            value={state.domains_input}
            onChange={handleInputChange}
            onBlur={handleBlur}
          />
        </Form.Group>
        {state.domains.length > 0 && (
          <div className='domain-tags-container'>
            {state.domains.map((domain, index) => (
              <Badge
                key={index}
                className='misc-badges'
              >
                <span>{domain}</span>
                <span onClick={() => removeDomain(index)}> &times;</span>
              </Badge>
            ))}
          </div>
        )}
        <div className='update-sysprop-domains__button'>
          <Button
            variant='outline-success'
            disabled={state.domains.length === 0}
            onClick={handleSubmit}
          >
            Update
          </Button>
        </div>
      </Form>
    </div>
  )
}

export default UpdateSysprop